import axios from 'axios'
import store from '../store'
import Vue from 'vue';
import i18n from '../translations'

const defaultOptions = {
  authorize: true,
}
export function request(method, options, $type = null) {
  const localOpts = {
    ...defaultOptions,
    ...options,
  }
  let Headers = {
    "Content-Type": "application/json",
  }
  if (localOpts.authorize) {
    Headers.Authorization = `Bearer ${store.state.auth.bearer}`
  }

  return axios({
    method,
    mode: "cors",
    data: options.data,
    url: options.url,
    params: options.params,
    Headers,
  }).then((response) => {
    if($type === "createOrderService"){
      if(response.data.length){
        let doc;
        if(response.data === "error"){
          // Vue.notify({
          //   group: 'error',
          //   type: 'error',
          //   title: `${ i18n.t('orders.orderNotCreated')}`,
          //   text: `${ i18n.t('orders.orderNotCreatedText')}`,
          //   duration: 5000
          // });
        }else{
          for (doc in response.data) {
            //Vue.alert(this.$t('order.orderCreated'), this.$t('order.orderThanksTitle'));
            Vue.alert(`${ i18n.t('orders.orderCreated')}`,`${ i18n.t('orders.orderThanksTitle')}`,"success");
          }
        }
      }else{
        //Vue.alert(this.$t('order.orderCreated'), this.$t('order.orderThanksTitle'));
        Vue.alert(`${ i18n.t('orders.orderCreated')}`,`${ i18n.t('orders.orderThanksTitle')}`,"success");
      }
    }
    return response;
  }, (error) => {
    // Vue.notify({
    //   group: 'error',
    //   type: 'error',
    //   title: `${ i18n.t('orders.orderNotCreated')}`,
    //   text: `${ i18n.t('orders.orderNotCreatedText')}`,
    //   duration: 5000
    // });
  }).catch(response => {
    console.log(response);
    // Vue.notify({
    //   group: 'error',
    //   type: 'error',
    //   title: `${ i18n.t('order.orderNotCreated')}`,
    //   text: `${ i18n.t('order.orderNotCreatedText')}`,
    //   duration: 5000
    // });
  });;
}
